// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__rYzBI","col":"CardReaderDesc_col__2h5FC","label":"CardReaderDesc_label__1qNFa"};